import React, { useEffect } from 'react';

import ExpressStore from '@/stores/express';
import SkuStore from '@/stores/sku';

import Action from '@/component/module_actions';
import Express from '@/component/module_actions/express';
import Sku from '@/component/module_sku';

import Price from '../module_actions/price';
import Total from '../module_actions/total';

import './index.less';

interface PropType {
  sku: SkuTypes.PropTypes;
  inventory: InventoryTypes.Root;
  productId: string;
  sourcingTradeAvailable: boolean;
  productEncryptId: string;
  abtest: DetailTypes.Abtest;
  umidToken: string;
  i18n: DetailTypes.i18n;
}

export default function Index(props: ActionTypes.Root & PropType) {
  const expressInfo = ExpressStore(state => state.product);
  const skuInfo = SkuStore(state => state.product);
  const { abtest } = props || {};

  const handleClick = (event: any) => {
    const element = event.currentTarget;
    const btnType = element.getAttribute('data-type-btn');
    if (btnType) {
      // 询盘和沟通拦截
      if (['chat', 'inquiry'].indexOf(btnType) > -1) {
        event.stopPropagation();
        window.parent.postMessage(
          {
            from: 'quickView',
            event: 'button',
            action: btnType === 'inquiry' ? 'contact' : 'chat',
          },
          '*'
        );
      }
    }
  };

  const handleRemove = (event: Event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const actionClass = '.quick-total a,.logo-list';

  const bindAction = () => {
    const elements = document.querySelectorAll('[data-type-btn]');
    const actions = document.querySelectorAll(actionClass);
    elements.forEach(element => {
      element.addEventListener('click', handleClick);
    });
    actions.forEach(element => {
      element.addEventListener('click', handleRemove);
    });
  };

  useEffect(() => {
    bindAction();
  }, [expressInfo.isEmpty]);

  const renderAction = () => {
    if (abtest.quick_view_detail_ab_test === 'test') {
      return (
        <div className="sku-bottom">
          {(skuInfo.skuActiveId || skuInfo.quantity > 0) && (
            <div className="quick-total">
              <Price {...props} />
              <Express {...props} />
              <Total {...props} />
            </div>
          )}
          <Action
            {...props}
            renderConfig={{
              showType: 'quick',
              testType: 'quick',
            }}
          />
        </div>
      );
    }
    if (skuInfo.price) {
      return (
        <div className="sku-bottom">
          <div className="quick-total">
            <Price {...props} />
            <Express {...props} />
            <Total {...props} />
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="quick-layout dialog-layout">
        <Sku
          {...props}
          renderConfig={{
            showType: 'quick',
          }}
        />
        {renderAction()}
      </div>
    </>
  );
}
